import { useRunOnce } from '../components/common/useRunOnce';
import { useCrmOrgs } from '../components/pages/environments/useCrmOrgs';

export const useLoadOrgs = () => {
  const { getAllConnectedOrgs } = useCrmOrgs();

  useRunOnce(() => {
    getAllConnectedOrgs();
  });
};
